// eslint-disable-next-line no-relative-import-paths/no-relative-import-paths
import PackageJson from "../../package.json"
import {type Environment} from "@environment/types"

/**
 * Configuration for preview deployments (i.e. all deployments to non-prod environments).
 */
export const environment: Environment = {
    production: true,
    name: "dev2",
    version: PackageJson.version,

    auth: {
        google: {
            clientId: "608675176242-9a7778mmllu4026o5m3ehi2n58vir03n.apps.googleusercontent.com",
        },
        microsoft: {
            clientId: "151d8cd7-eff9-441e-b8b9-1072287949cb",
        },
    },

    firebase: {
        apiKey: "AIzaSyDqR6iVJVmCfuo1mYh72xRfPu6k14yxmSs",
        authDomain: "cm-platform-dev2-6aa17.firebaseapp.com",
        projectId: "cm-platform-dev2",
        storageBucket: "cm-platform-dev2.firebasestorage.app",
        messagingSenderId: "633811143195",
        appId: "1:633811143195:web:60cbc8dfafa44243cf86be",
    },
    firebaseConfig: {
        collectionEnabled: true,
    },

    rendering: {
        materialAssets: {
            fallbackTemplateId: 17484,
            samples: 64,
        },
        shaderBall: {
            templateId: 17482,
        },
        defaultQueueDomain: "colormass",
        maxConcurrentRenderJobs: 200,
    },

    storage: {
        bucketsPrefix: "cm-platform-dev2-",
        usePostToUpload: false,
    },

    style: {
        application: {
            background: "#991b1b40",
        },
    },

    debug: {
        enableCallStack: false,
    },

    onboarding: {
        allowSkipPayment: false,
    },

    stripe: {
        fullyIntegrated: false,
    },

    configuratorUrl: "https://configurator-dev2.colormass.com?apiVersion=2",
    platformDeployUrl: "https://dev2.colormass.com",
    configuratorDeployUrl: "https://configurator-dev2.colormass.com",
    gqlApiEndpoint: "https://gql-dev2.colormass.com",
    jobsInstanceUrl: "https://jobs-dev2.colormass.com",
    localTilingEndpoint: "ws://localhost:5678/",
}
